"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=HOGDescriptor.js.map